import { z } from 'zod';

/** Notification / app preferences returned by `GET /v1/me/preferences`. */
export const preferencesSchema = z.object({
  pushEnabled: z.boolean(),
  emailOptIn: z.boolean(),
  marketingOptIn: z.boolean(),
  updatedAt: z.string().optional(),
});

export type Preferences = z.infer<typeof preferencesSchema>;

/**
 * Partial update for `PUT /v1/me/preferences`. Every field is optional so the
 * client can toggle a single switch; at least one must be present.
 */
export const updatePreferencesInputSchema = z
  .object({
    pushEnabled: z.boolean().optional(),
    emailOptIn: z.boolean().optional(),
    marketingOptIn: z.boolean().optional(),
  })
  .refine((data) => Object.keys(data).length > 0, {
    message: 'At least one preference must be provided',
  });

export type UpdatePreferencesInput = z.infer<typeof updatePreferencesInputSchema>;

/** Privacy-friendly defaults applied when a user has no preferences row yet. */
export const DEFAULT_PREFERENCES: Preferences = {
  pushEnabled: true,
  emailOptIn: true,
  marketingOptIn: false,
};
